module.exports = __webpack_public_path__ + "img/plataforma-limer-inverse.83af9706.png";